import React from "react";
import { connect } from "react-redux";
import Box from "@material-ui/core/Box";
import { columns } from "./utils";

import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  HeaderFilter,
  Sorting,
  Editing
} from "devextreme-react/data-grid";
import {
  addModuleSiteAction,
  updateModuleSiteAction,
  deleteModuleSiteAction
} from "../../../../store/actions";

const ElectronicResource = ({
  allModuleSiteList,
  addSite,
  updateSite,
  deleteSite
}) => {
  const createSite = data => {
    const newSite = {
      type: 1,
      main: {
        name: data.name,
        url: data.url
      }
    };
    addSite(newSite);
  };

  const updatedSite = data => {
    const updatedSite = {
      main: {
        name: data.name,
        url: data.url
      }
    };
    updateSite(data.id, updatedSite);
  };

  return (
    <div>
      <Box fontSize={14} mb={2}>
        Электронные ресурсы
      </Box>
      <Box>
        <DataGrid
          elementAttr={{
            id: "gridContainer"
          }}
          wordWrapEnabled
          errorRowEnabled={false}
          showBorders
          dataSource={allModuleSiteList}
          onRowInserted={event => createSite(event.data)}
          onRowUpdated={event => updatedSite(event.data)}
          onRowRemoved={event => deleteSite(event.data.id)}
        >
          {columns.map((column, idx) => (
            <Column key={idx} {...column} defaultSortOrder="asc" />
          ))}
          <Editing mode="row" allowUpdating allowDeleting allowAdding />
          <Sorting showSortIndexes={false} visible />
          <HeaderFilter visible />
          <FilterRow visible />
          <Scrolling mode="virtual" />
          <LoadPanel enabled />
        </DataGrid>
      </Box>
    </div>
  );
};

const mapStateToProps = state => ({
  allModuleSiteList: state.modules.allModuleSiteList
});

const mapDispatchToProps = dispatch => ({
  addSite: site => dispatch(addModuleSiteAction(site)),
  updateSite: (idSite, data) => dispatch(updateModuleSiteAction(idSite, data)),
  deleteSite: idSite => dispatch(deleteModuleSiteAction(idSite))
});

export default connect(mapStateToProps, mapDispatchToProps)(ElectronicResource);
